// src/components/Header.jsx

import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../Images/torque energy bg no.png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="container">
      <header>
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Torque Energy Logo" />
          </Link>
        </div>

        {/* Hamburger icon, only visible on mobile via CSS */}
        <button className="mobile-menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <i className="fas fa-times"></i> : <i className="fas fa-bars"></i>}
        </button>

        {/* Wrapper for navigation and search */}
        <div className={`header-nav-group ${isMenuOpen ? 'nav-open' : ''}`}>
          <nav>
            <ul>
              <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li><Link to="/products" onClick={() => setIsMenuOpen(false)}>Products</Link></li>
              <li><Link to="/team" onClick={() => setIsMenuOpen(false)}>Team</Link></li>
              <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About Us</Link></li>
              <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
            </ul>
          </nav>

          <div className="search-container">
            <i className="fas fa-search search-icon"></i>
            <input type="text" className="search-input" placeholder="Search..." />
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;